import WrapperContent from "./WrapperContent";
export default WrapperContent